import { db } from './firebase';
import { firestoreKeys } from '../utils/constants';

function useAdminService() {
  const getAdmin = (id) =>
    db
      .collection(firestoreKeys.Admin)
      .doc(id)
      .get()
      .then((res) => res.data());

      const getStudent = async (id) => {
        try {
          const studentDoc = await db.collection(firestoreKeys.Students).doc(id).get();
          const student = studentDoc.data();
      
          if (!student) return null;
      
          if (student.ModulesPaid?.length) {
            const modules = await Promise.all( 
              student.ModulesPaid.map(async (moduleData) => {
                try {
                  if (moduleData?.ModuleReference) {
                    const moduleDoc = await moduleData.ModuleReference.get();
                    if (moduleDoc.exists) {
                      return {
                        ...moduleDoc.data(),
                        PurchaseDate: moduleData.PurchaseDate?.toDate() || null,
                      };
                    }
                  }
                } catch (error) {
                  console.error("Error fetching module:", error);
                }
                return null;
              })
            );
      
            return { ...student, ModulesPaid: modules.filter(Boolean) }
          }
      
          return student;
        } catch (error) {
          console.error("Error fetching student:", error);
          return null;
        }
      };
      

  return { getAdmin, getStudent };
}

export default useAdminService;
